import { Coord } from "../../../../src/types/Interface";
import { normalizeRadian } from "../../../../src/utils/normalizeRadian";


export function getTangentCoords(cPoint: Coord, cirPoint: Coord, lenght: number): Coord[] {
  const r = Math.atan2(cirPoint.y - cPoint.y, cirPoint.x - cPoint.x);
  const t = normalizeRadian(r + Math.PI / 2);
  const generatePoint = (l: number) => ({ x: cirPoint.x + Math.cos(t) * l, y: cirPoint.y + Math.sin(t) * l })
  return [generatePoint(-lenght / 2), generatePoint(lenght / 2)]
}